import React,{createContext} from "react";


const SideBarContext = createContext(null);

export default SideBarContext;